import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IdDescription } from 'tms-lib';
import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class ShippingServiceReferenceService extends BaseReferenceService {
  constructor() {
    super('ShippingServiceReference');
  }

  getForSupplier(supplierId: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetForSupplier/${supplierId}`);
  }

  getDeliveryProducts(shippingServiceId: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetDeliveryProducts/${shippingServiceId}`);
  }
}
